import { createIcon } from "@chakra-ui/react";

export const VectorDots = createIcon({
  displayName: "VectorDots",
  viewBox: "0 0 4 16",
  path: (
    <svg width="4" height="16" viewBox="0 0 4 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 2H2.01M2 8H2.01M2 14H2.01" stroke="#29B5C3" strokeWidth="3" strokeLinecap="round"/>
    </svg>
  ),
});
